import InnerHTML from "dangerously-set-html-content";
import {useEffect, useRef, useState} from "react";
import Modal from "react-bootstrap/Modal";
import {useListContext} from "../../contexts/ListContext";
import {DataType, FigureType} from "../../types/enums";
import {Correlation, Score} from "../../types/list";
import {applyHighlight, HIGHLIGHT_FIGURE_TYPES} from "../../utils/plotHighlight";

/**
 * Modal component to display a larger view of a figure with metadata.
 */
const ListFigureModal = () => {
  const {listState, setShowFigureModal} = useListContext();
  const containerRef = useRef<HTMLDivElement>(null);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    setShowFigureModal(undefined);
  };

  useEffect(() => {
    setShow(!!listState.showFigureModal);
  }, [listState.showFigureModal]);

  useEffect(() => {
    if (!show) return;

    const figureType = listState.showFigureModal?.figure_type as FigureType | undefined;
    if (!figureType || !HIGHLIGHT_FIGURE_TYPES.includes(figureType)) return;

    const row = listState.dataType === DataType.Correlations
      ? listState.selectedRowModal as Correlation | null
      : listState.selectedRowModal as Score | null;

    return applyHighlight(containerRef.current, figureType, row, 15);
  }, [show, listState.showFigureModal]);

  return <Modal
    show={show}
    backdrop="static"
    centered
    size="lg"
    dialogClassName="figure-modal"
    onHide={handleClose}
  >
    <Modal.Header closeButton className="border-0">
      <div className="d-flex flex-column align-items-center w-100">
        <Modal.Title>{listState.showFigureModal?.meta.title}</Modal.Title>
        <Modal.Title className="fw-bold">{listState.showFigureModal?.meta.subtitle}</Modal.Title>
        <Modal.Title>{listState.showFigureModal?.meta.description}</Modal.Title>
      </div>
    </Modal.Header>
    <Modal.Body>
      <div className="d-block h-100 w-100" ref={containerRef}> {/* Figure requires block display for proper sizing */}
        <InnerHTML className="figure-wrapper h-100"
                   html={!listState.showFigureModal ? "<div></div>" : listState.showFigureModal.html}/>
      </div>
    </Modal.Body>
  </Modal>
};

export default ListFigureModal;
